import { generateTimelogData } from "../constants";
import moment from "moment";

const STORAGE_KEY = "timelog_data";

/* ----------------------------------------------
   Load or initialize timelogs in localStorage
---------------------------------------------- */
export function loadTimelogs() {
  const stored = localStorage.getItem(STORAGE_KEY);

  if (stored) {
    try {
      return JSON.parse(stored);
    } catch (err) {
      console.error("Invalid timelog data:", err);
    }
  }

  // First-time → generate demo data
  const initial = generateTimelogData();
  localStorage.setItem(STORAGE_KEY, JSON.stringify(initial));
  return initial;
}

/* ----------------------------------------------
   Save timelog array back to storage
---------------------------------------------- */
export function saveTimelogs(timelogs) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(timelogs));
}

/* ----------------------------------------------
   FETCH FUNCTIONS
---------------------------------------------- */
export async function fetchAllTimelogs() {
  return loadTimelogs();
}

export async function fetchTimelogsByMonth(year, month) {
  const all = loadTimelogs();
  return all.filter((log) => {
    const d = moment(log.date);
    return d.year() === year && d.month() === month;
  });
}

export async function fetchTimelogsByDateRange(start, end) {
  const all = loadTimelogs();
  return all.filter((log) => log.date >= start && log.date <= end);
}

/* ----------------------------------------------
   CRUD OPERATIONS
---------------------------------------------- */

/**
 * Add new timelog
 */
export function addTimelog(newLog) {
  const all = loadTimelogs();

  const entry = {
    ...newLog,
    id: `${Date.now()}-${Math.random()}`,
    createdAt: moment().toISOString(),
  };

  const updated = [...all, entry];
  saveTimelogs(updated);

  return entry;
}

/**
 * Update existing log by ID
 */
export function updateTimelog(id, updates) {
  const all = loadTimelogs();

  const updated = all.map((log) =>
    log.id === id ? { ...log, ...updates } : log
  );

  saveTimelogs(updated);
  return true;
}

/**
 * Delete one log
 */
export function deleteTimelog(id) {
  const all = loadTimelogs();

  const updated = all.filter((log) => log.id !== id);

  saveTimelogs(updated);
  return true;
}

/**
 * Add leave entry for a date
 */
export function addLeave(date) {
  const all = loadTimelogs();

  const exists = all.some((l) => l.date === date && l.type === "leave");
  if (exists) return false;

  const leaveEntry = {
    id: `leave-${Date.now()}`,
    date,
    type: "leave",
    title: "Leave",
    duration: 0,
    tag: "other",
    notes: "",
    createdAt: moment().toISOString(),
  };

  saveTimelogs([...all, leaveEntry]);
  return leaveEntry;
}

/**
 * Remove leave entry for a date
 */
export function removeLeave(date) {
  const all = loadTimelogs();

  const updated = all.filter(
    (log) => !(log.date === date && log.type === "leave")
  );

  saveTimelogs(updated);
  return true;
}
